(function () {
  'use strict';
  angular.module('vctracker')
    .component('trackervaluenew', {
      restrict: 'E',
      bindings: {
        clientid: '<',
        trackerid: '<?',
        onentrycb: '&?'
      },
      template: `
      <div class="trackervaluenew-component" data-hook="trackervaluenew-component">
        <h3>Meßwerte eingeben</h3>
        <div class="row" ng-show="vm.trackers.length == 0">
          <div class="col-xs-12">
            <div class="alert alert-info">
              <i class="fa fa-info-circle fa-2x"></i> Sie haben noch keine Meßwert-Tracker definiert. Legen Sie einen <a href="/#/settings/tracker" style="text-decoration: underline;">neuen Meßwert-Tracker</a> im Einstellungsmenü an.
           </div>
          </div>
        </div>
        <div class="row" ng-repeat="t in vm.trackers" ng-show="vm.trackers.length > 0">
            <div class="col-xs-12 col-md-6">
              <!-- TODO: graph trackervalues -->
              <div class="panel panel-info">
                  <div class="panel-heading">
                    <span class="pull-left">{{t.name}}</span>
                    <span class="pull-right">
                      <div class="btn btn-primary btn-xs" ng-click="vm.snapshot()" ng-show="vm.plotlyref"><i class="fa fa-camera"></i></div>
                      <div class="btn-group" ng-init="showtable = false">
                          <label class="btn btn-primary btn-xs" ng-model="showtable" uib-btn-radio="false"><i class="fa fa-line-chart"></i> </label>
                          <label class="btn btn-primary btn-xs" ng-model="showtable" uib-btn-radio="true"><i class="fa fa-table"></i> </label>
                      </div>
                    </span>
                    <span class="clearfix"></span>
                  </div>
                  <div class="panel-body">
                    <trackervaluegraph ng-hide="showtable === true" trackerid="t._id" clientid="vm.clientid" 
                        snapshothandle="vm.addSnapShotReference(snapshot)"></trackervaluegraph>
                    <trackervaluelist  ng-show="showtable === true" trackerid="t._id" clientid="vm.clientid"></trackervaluelist>
                  </div>
                </div>
            </div>
            <div class="col-xs-12 col-md-6">
                <div class="panel panel-info">
                <div class="panel-heading">{{t.name}}:
                    <span ng-if="t.def.length === 1">Neuen Wert eingeben</span>
                    <span ng-if="t.def.length > 1">Neue Werte eingeben</span>
                </div>
                <div class="panel-body">
                    <trackervalueform trackervalue="vm.newvalues[t._id]"
                                      trackerid="t._id"
                                      parentsave="vm.saveNewTrackervalue(trackervalue, trackerid)"
                                      oncancel="vm.cancel()">
                    </trackervalueform>
                </div>
            </div>
        </div>
      </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Trackervalue', 'Tracker', 'Rlog', 'vertxEventBusService',
        function ($log, Trackervalue, Tracker, Rlog, vertxEventBusService) {
          let vm = this;
          vm.addTrackervalue = addTrackervalue;
          vm.saveNewTrackervalue = saveNewTrackervalue;
          vm.addSnapShotReference = addSnapShotReference;
          vm.cancel = cancel;

          vm.$onInit = function () {
            vm.values = {};
            vm.newvalues = {};

            // If trackerid is not defined load all active trackers
            // Show UI for each Tracker on patient/client Tracker page
            if (angular.isUndefined(vm.trackerid)) {
              getTrackers({active: true});
            }

            // Show only UI for Tracker identified by trackerid
            else if (angular.isString(vm.trackerid) && vm.trackerid.length > 0) {
              getTrackers({active: true, _id: vm.trackerid});
            }
          };

          // clientid might be propagating late
          // clientid is only needed to add new tracking data
          vm.$onChanges = function (changes) {
            if (angular.isDefined(changes.clientid) &&
              angular.isDefined(changes.clientid.currentValue &&
                changes.clientid.currentValue.length > 0)) {
              vm.clientid = changes.clientid.currentValue;
            }

            // trackeridid might be propagating late
            if (angular.isDefined(changes.trackerid) &&
              angular.isDefined(changes.trackerid.currentValue &&
                changes.trackerid.currentValue.length > 0)) {
              vm.trackerid = changes.trackerid.currentValue;
              getTrackers({active: true, _id: vm.trackerid});
            }
          };


          function getTrackers(query) {
            Tracker.$search(query).$then(function (tr) {
              let date = moment();
              vm.trackers = tr;
              vm.trackers.map(function (t) {
                vm.newvalues[t._id] = {
                  name: t.name,
                  trackerid: t._id,
                  def: angular.copy(t.def),
                  dateiso: date.toISOString(),
                  datesortable: date.format('YYYY-MM-DD'),
                  dateat: date.format('DD.MM.YYYY'),
                  datejs: date.format(),
                  datesv: date.format('DDMMYY')
                };
              });
            });
          }

          function addTrackervalue() {
            vm.newtrackervalue = {};
            delete vm.created;
            delete vm.canceled;
          }

          function saveNewTrackervalue(trackervalue, trackerid) {
            $log.debug('debug: saving new trackervalue: ', trackervalue);
            trackervalue.trackerid = trackerid;
            trackervalue.clientid = vm.clientid;
            trackervalue.patientid = vm.clientid;
            Trackervalue.$create(trackervalue).$then(function () {
              vm.created = true;
              if (angular.isDefined(vm.onentrycb) && angular.isFunction(vm.onentrycb)) {
                $log.debug('calling onentrycb with: ', trackervalue);
                vm.onentrycb({trackervalue: trackervalue});
              }
            }, function (err) {
              vm.created = false;
              $log.error('Creation of new trackervalue failed: ', err);
              Rlog.error('vctrackervalue', 'trackervaluenew', 'Creation of new trackervalue failed: ', {trackervalue: vm.newtrackervalue});
            });
          }

          function cancel() {
            delete vm.newtrackervalue;
            vm.canceled = true;
          }

          function addSnapShotReference(snapshot) {
            $log.debug('debug: adding new snapshot reference: ', snapshot);
            vm.snapshot = snapshot;
            vertxEventBusService.publish('trackerimage.new', {clientid: vm.clientid, image: snapshot, trackerid: vm.trackerid});
          }


        }] // controller
    }); // component

// klammerfriedhof
}());
